export default {"src":"/_next/static/media/success.fb6f0698.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};